import _objectSpread from '@babel/runtime/helpers/esm/objectSpread';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'pp-vx/dist/components/icons/icons.css';
import React from 'react';
import clsx from 'clsx';

var iconClass = 'ppvx_icon';

function Icon(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'span' : _ref$as,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'acorns' : _ref$name,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      rest = _objectWithoutProperties(_ref, ["as", "size", "name", "className"]);

  return React.createElement(as, _objectSpread({
    className: clsx(iconClass, "".concat(iconClass, "--size_").concat(size), "".concat(iconClass, "-").concat(name), className)
  }, rest));
}

export { Icon };
